module.exports = __webpack_public_path__ + "9a988d0accf55af94aae42a89c1e1546.svg";